import moment from "moment";

export const server = {
  baseUrl: "/api",
};

export function formatDate(dateString) {
  return moment(dateString).format("dddd, DD MMMM YYYY");
}

export function removeSpaces(string) {
  return string.replace(/\s/g, "");
}

export function formatMonth(monthString) {
  return moment(monthString).format("MMMM YYYY");
}

export function addSpaces(string) {
  let index = 0;
  for (const s in string) {
    if (s >= "0" && s <= "9") {
      index = string.indexOf(s) - 1;
      break;
    }
  }

  return string.substr(0, index) + " " + string.substr(index);
}

export function getYear(string) {
  return moment(string).year();
}

export function getMonth(string) {
  return moment(string).format("MM");
}

export function getMonthAndYear(string) {
  return moment(string).format("YYYY-MM");
}
